module.exports = __webpack_public_path__ + "img/salon-friendliness.fee91313.svg";